export default "__VITE_ASSET__BtM8T8HG__"